function Brand({ compact = false }) {
  return (
    <div className={compact ? 'brand brand-compact' : 'brand'}>
      <img className="brand-logo-image" src="/logo512.png" alt="Saqar Al-Jazeera" />
    </div>
  );
}

export default Brand;
